var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1589 9.1589L6.79876 7.51223L5.1589 5.86556C5.09336 5.80444 5.04544 5.72671 5.02021 5.64054C4.99497 5.55438 4.99334 5.46297 5.0155 5.37596C5.03766 5.28894 5.08278 5.20953 5.1461 5.14611C5.20943 5.08268 5.28863 5.03758 5.37534 5.01556C5.4619 4.99335 5.55282 4.99494 5.63856 5.02016C5.7243 5.04538 5.8017 5.0933 5.86265 5.15889L7.85438 7.15889C7.94762 7.25264 8 7.37973 8 7.51223C8 7.64473 7.94762 7.77181 7.85438 7.86556L5.86265 9.86556C5.76828 9.95399 5.64339 10.0022 5.51434 9.99993C5.38528 9.99769 5.26213 9.94521 5.17085 9.85356C5.07958 9.76191 5.02733 9.63825 5.0251 9.50865C5.02287 9.37906 5.07084 9.25366 5.1589 9.1589Z",
    fill: "#2173FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9 0H15.1C15.8728 0 16.5 0.6272 16.5 1.4V14.6C16.5 14.9713 16.3525 15.3274 16.0899 15.5899C15.8274 15.8525 15.4713 16 15.1 16H1.9C1.5287 16 1.1726 15.8525 0.910051 15.5899C0.6475 15.3274 0.5 14.9713 0.5 14.6V1.4C0.5 0.6272 1.1272 0 1.9 0ZM1.7 1.4V14.6C1.7 14.7104 1.7896 14.8 1.9 14.8H10.9V1.2H1.9C1.84696 1.2 1.79609 1.22107 1.75858 1.25858C1.72107 1.29609 1.7 1.34696 1.7 1.4ZM12.1 14.8H15.1C15.153 14.8 15.2039 14.7789 15.2414 14.7414C15.2789 14.7039 15.3 14.653 15.3 14.6V1.4C15.3 1.34696 15.2789 1.29609 15.2414 1.25858C15.2039 1.22107 15.153 1.2 15.1 1.2H12.1V14.8Z",
    fill: "#2173FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.60cca8e3bebc61fcb9a5b4f024ae3618.svg";
export { ForwardRef as ReactComponent };